import axios from "axios";
import * as Sentry from "@sentry/react";
export class GetExchangeRates {
    async getExchangeRates(symbol) {
        const apiUrl = process.env.REACT_APP_API_URL;
        return axios.get(`${apiUrl}/exchange_rates`, { timeout: 5000 })
            .then(response => response.data)
            .catch(error => {
            Sentry.captureException(error, {
                tags: { component: "GetExchangeRates", operation: "fetch-exchange-rates" },
                extra: { apiUrl, symbol },
            });
            throw error;
        });
    }
}
